"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcLinkConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcLinkConstants = (function () {
    function BcLinkConstants() {
    }
    BcLinkConstants.BC_LINK_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-link");
    BcLinkConstants.LINK_DEFAULT = 'link-default';
    BcLinkConstants.LINK_SMALL = 'link-small';
    BcLinkConstants.LINK_LARGE = 'link-large';
    BcLinkConstants.LINK_UNDERLINE = 'link-underline';
    BcLinkConstants.LINK_UNDERLINE_DEFAULT = 'link-underline-default';
    BcLinkConstants.LINK_UNDERLINE_SMALL = 'link-underline-small';
    BcLinkConstants.LINK_UNDERLINE_LARGE = 'link-underline-large';
    return BcLinkConstants;
}());
exports.BcLinkConstants = BcLinkConstants;
